import { LRParser } from '@lezer/lr';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const Json$1 = 1,
  Logfmt$1 = 2,
  Unpack$1 = 3,
  Pattern$1 = 4,
  Regexp$1 = 5,
  Unwrap$1 = 6,
  LabelFormat$1 = 7,
  LineFormat$1 = 8,
  LabelReplace$1 = 9,
  Vector$1 = 10,
  Offset$1 = 11,
  Bool$1 = 12,
  On$1 = 13,
  Ignoring$1 = 14,
  GroupLeft$1 = 15,
  GroupRight$1 = 16,
  Decolorize$1 = 17,
  Drop$1 = 18,
  Keep$1 = 19,
  By$1 = 20,
  Without$1 = 21,
  And$1 = 22,
  Or$1 = 23,
  Unless$1 = 24,
  Sum$1 = 25,
  Avg$1 = 26,
  Count$1 = 27,
  Max$1 = 28,
  Min$1 = 29,
  Stddev$1 = 30,
  Stdvar$1 = 31,
  Bottomk$1 = 32,
  Topk$1 = 33,
  Sort$1 = 34,
  Sort_Desc$1 = 35,
  MetricExpr$1 = 93;

const keywordTokens = {
  json: Json$1,
  logfmt: Logfmt$1,
  unpack: Unpack$1,
  pattern: Pattern$1,
  regexp: Regexp$1,
  label_format: LabelFormat$1,
  line_format: LineFormat$1,
  label_replace: LabelReplace$1,
  vector: Vector$1,
  offset: Offset$1,
  bool: Bool$1,
  on: On$1,
  ignoring: Ignoring$1,
  group_left: GroupLeft$1,
  group_right: GroupRight$1,
  unwrap: Unwrap$1,
  decolorize: Decolorize$1,
  drop: Drop$1,
  keep: Keep$1,
};

const specializeIdentifier = (value) => {
  return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
  by: By$1,
  without: Without$1,
  and: And$1,
  or: Or$1,
  unless: Unless$1,
  sum: Sum$1,
  avg: Avg$1,
  count: Count$1,
  max: Max$1,
  min: Min$1,
  stddev: Stddev$1,
  stdvar: Stdvar$1,
  bottomk: Bottomk$1,
  topk: Topk$1,
  sort: Sort$1,
  sort_desc: Sort_Desc$1,
};

const extendIdentifier = (value) => {
  return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,ip:291, count_over_time:297, rate:299, rate_counter:301, bytes_over_time:303, bytes_rate:305, avg_over_time:307, sum_over_time:309, min_over_time:311, max_over_time:313, stddev_over_time:315, stdvar_over_time:317, quantile_over_time:319, first_over_time:321, last_over_time:323, absent_over_time:325, bytes:331, duration:333, duration_seconds:335};
const parser = LRParser.deserialize({
  version: 14,
  states: "EtOYQPOOO#cQPO'#DUO$rQPO'#DTOYQPO'#DTOOQO'#E_'#E_O%PQPO'#E^OOQO'#Ez'#EzO%UQPO'#EyQ%aQPOOOOQO'#FY'#FYO&bQPO'#FYO&gQPO'#FZO&lQPO'#F[OOQO'#E]'#E]OOQO'#DS'#DSOOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnO&qQPO'#DWOOQO'#DV'#DVO'PQPO,59pOOQO'#Dc'#DcO'XQPO'#DbO'aQPO'#DaO(zQPO'#D`O*eQPO'#D`OOQO'#D_'#D_O,gQPO,59oO-uQPO,59oO-|QPO,5:wO.TQPO,5:xO.`QPO'#EwO0kQPO,5;eO0rQPO,5;eO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gOOQO,5;t,5;tOYQPO,5;uO3ZQPO,5;vO3`QPO,59rO#cQPO,59qOOQO1G/[1G/[OOQO'#Df'#DfO3eQPO,59|O5OQPO,59|OOQO'#Dg'#DgO5TQPO,59{OOQO,59{,59{O5]QPO'#DWO5zQPO'#DjO7kQPO'#DmO9XQPO'#DmOOQO'#Dm'#DmOOQO'#Dt'#DtOOQO'#Dr'#DrO+TQPO'#DrO9^QPO,59zO:wQPO'#EQO:|QPO'#EROOQO'#EU'#EUO;RQPO'#EVO;WQPO'#EYOOQO,59z,59zOOQO,59y,59yOOQO1G/Z1G/ZOOQO1G0c1G0cO;]QPO'#EoO.WQPO'#EoO;qQPO1G0dO;vQPO1G0dO;{QPO,5;cO<TQPO1G1PO=`QPO1G1PO=gQPO1G1PO=nQPO'#E}O?|QPO'#E|O@WQPO'#E|OYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1RO@bQPO1G1aO@iQPO1G1bOOQO1G/^1G/^OOQO1G/]1G/]O5TQPO1G/hO@nQPO1G/hO@sQPO'#DhOB^QPO'#DhOOQO1G/g1G/gOBcQPO,59rOBtQPO,5:aOOQO'#Dk'#DkOCPQPO,5:UODpQPO'#DpOOQO'#Do'#DoOF^QPO,5:]OGwQPO,5:YOOQO,5:X,5:XOIbQPO,5:^O+TQPO,5:^O+TQPO,5:^OOQO,5:l,5:lOIpQPO'#ETOOQO'#ES'#ESOIuQPO,5:mOK`QPO'#EXOOQO'#EX'#EXOOQO'#EW'#EWOMPQPO,5:qONjQPO'#E[OOQO'#E['#E[OOQO'#EZ'#EZO!!ZQPO,5:tO!#tQPO'#D`O;]QPO,5;ZO!#{QPO'#EpO!$QQPO,5;ZO!$kQPO,5;ZO!$uQPO,5;ZO!$|QPO,5;ZO!%RQPO7+&OO.WQPO7+&OOOQO'#Ex'#ExO!&cQPO1G0}OOQO1G0}1G0}O!&kQPO7+&kOYQPO7+&kO!'{QPO7+&kO!(SQPO7+&kO!(ZQQO'#FOOOQO,5;i,5;iO!*iQPO,5;hO!*pQPO,5;hO!,RQPO7+&mO!,YQPO7+&mOOQO7+&m7+&mO!,gQPO7+&mO!,nQPO7+&mO!-sQPO7+&mO!.TQPO7+&{OOQO7+&|7+&|OOQO7+%S7+%SO!.YQPO7+%SO5TQPO,5:SO!._QPO,5:SO!.dQPO1G/yOOQO1G/{1G/{OOQO1G0S1G0SOOQO1G0U1G0UOOQO,5:V,5:VO!.iQPO1G/wO!0SQPO,5:[O!0XQPO,5:ZOOQO1G/x1G/xO!0^QPO1G/xO!1wQPO,5:oO:|QPO,5:nO;RQPO,5:rO;WQPO,5:uO!2PQPO,5;^O!$QQPO1G0uO!2_QPO1G0uO!2gQPO,5;[O+TQPO,5;^O!2lQPO1G0uO!2sQPO'#EqO!2xQPO1G0uO!2lQPO1G0uO!3QQPO1G0uO!3XQPO1G0uO;lQPO1G0uOOQO1G0u1G0uOOQO<<Ij<<IjO!3dQPO<<IjO!3iQPO,5;dOOQO7+&i7+&iOOQO<<JV<<JVO!3nQPO<<JVOYQPO<<JVOOQO'#FQ'#FQO!3uQPO,5;jOOQO'#FP'#FPOOQO,5;j,5;jOOQO1G1S1G1SO!3}QPO1G1SO!6WQPO<<JgOOQO<<Hn<<HnOOQO1G/n1G/nO!6]QPO1G/nO!6bQPO7+%eOOQO1G/v1G/vOOQO1G/u1G/uOOQO1G0Z1G0ZOOQO1G0Y1G0YOOQO1G0^1G0^OOQO1G0a1G0aOOQO'#Es'#EsOOQO1G0x1G0xO!6gQPO1G0xOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO7+&a7+&aOOQO1G0v1G0vO!6lQPO1G0xO!7QQPO7+&aOOQO,5;],5;]O!7YQPO7+&aO;lQPO7+&aO!7aQPO7+&aO!7lQPOAN?UOOQO1G1O1G1OO!8|QPOAN?qO!:^QPOAN?qO!:eQQO1G1UOOQO1G1U1G1UOOQO7+&n7+&nO!:mQPOAN@ROOQO7+%Y7+%YO!:rQPO<<IPO!:wQPO7+&dO!:|QPO<<I{O!;UQPO<<I{O!;^QPO'#ErO!;cQPO<<I{OOQOG24pG24pOOQOG25]G25]OOQO1G1V1G1VOOQO7+&p7+&pO!;kQPOG25mOOQOAN>kAN>kO!;pQPO<<JOOOQOAN?gAN?gO!;uQPOAN?gO!;}QPOLD+XOOQOAN?jAN?jOOQO,5:m,5:mO!<SQPO!$'NsO!<XQPO!)9D_O!<^QPO!.K9yOOQO!4//e!4//eO:|QPO'#ERO!<cQPO'#D`O!=ZQPO,59oO!=eQPO'#DTOYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1RO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO!>pQPO7+&mO!>wQPO7+&mO!?UQPO7+&mO!@^QPO7+&mO!@eQPO7+&mO!?]QPO'#E{",
  stateData: "!@r~O$ROStOS~OXZOY[OiUOjUOkUOlUOmUOnUOoUOpUOqUOrUOsUO!sXO#vYO#wYO$SPO$WRO$Y_O$Z`O$[aO$]bO$^cO$_dO$`eO$afO$bgO$chO$diO$ejO$fkO$glO$hmO~O{nO~O!OqO!QqO!WqO!XqOfwXgwXhwX!jwX!lwX!mwX!nwX!owX#vwX#wwX#xwX#ywX#zwX#{wX~O!]uO$PwX$XwX~P#hO$WzO~Od{Oe{O$W|O~Of!POg!OOh!PO!O!TO!j!TO!l!TO!m!TO!n!TO!o!TO#v!QO#w!QO#x!RO#y!RO#z!RO#{!SO~O!s!UO~O$W!VO~O$W!WO~O|!XO!O!XO!P!XO!Q!XO~O$T!YO$U!ZO~O}!]O$V!_O~Og!`Of!TXh!TX!O!TX!Q!TX!W!TX!X!TX!]!TX!j!TX!l!TX!m!TX!n!TX!o!TX#v!TX#w!TX#x!TX#y!TX#z!TX#{!TX$P!TX$X!TX$i!TX$T!TX~O!OqO!QqO!WqO!XqOf!SXg!SXh!SX!]!SX!j!SX!l!SX!m!SX!n!SX!o!SX#v!SX#w!SX#x!SX#y!SX#z!SX#{!SX$P!SX$X!SX$i!SX$T!SX~OP!dOQ!cOR!fOS!eOT!eOV!lOW!kOa!mOb!nOc!oO{!bO$W!iO~O!OqO!QqO!WqO!XqOfwagwahwa!jwa!lwa!mwa!nwa!owa#vwa#wwa#xwa#ywa#zwa#{wa~O!]uO$Pwa$Xwa~P+]OfvXgvXhvX!OvX!jvX!lvX!mvX!nvX!ovX#vvX#wvX#xvX#yvX#zvX#{vX~O$X!rO~P,tO$X!sO~P,tO!s!wO$SPO$W!uO~O$W!xO~OXZOY[OiUOjUOkUOlUOmUOnUOoUOpUOqUOrUOsUO#vYO#wYO$SPO$WRO$Y_O$Z`O$[aO$]bO$^cO$_dO$`eO$afO$bgO$chO$diO$ejO$fkO$glO$hmO~O!s!zO~P.eO$W!{O~O[#OO]!|O^!|OX#pPY#pPi#pPj#pPk#pPl#pPm#pPn#pPo#pPp#pPq#pPr#pPs#pP!s#pP#v#pP#w#pP$S#pP$W#pP$Y#pP$Z#pP$[#pP$]#pP$^#pP$_#pP$`#pP$a#pP$b#pP$c#pP$d#pP$e#pP$f#pP$g#pP$h#pP~O!s#WO~O}#XO~Og#ZOf!Uah!Ua!O!Ua!Q!Ua!W!Ua!X!Ua!]!Ua!j!Ua!l!Ua!m!Ua!n!Ua!o!Ua#v!Ua#w!Ua#x!Ua#y!Ua#z!Ua#{!Ua$P!Ua$X!Ua$i!Ua$T!Ua~O$W#[O~O}#]O$V!_O~O|#`O!O#`O!P!XO!Q!XO!j#aO!l#aO!m#aO!n#aO!o#aO~O{#dO!`#bOf!^Xg!^Xh!^X!O!^X!Q!^X!W!^X!X!^X!]!^X!j!^X!l!^X!m!^X!n!^X!o!^X#v!^X#w!^X#x!^X#y!^X#z!^X#{!^X$P!^X$X!^X$i!^X$T!^X~O{#dOf!aXg!aXh!aX!O!aX!Q!aX!W!aX!X!aX!]!aX!j!aX!l!aX!m!aX!n!aX!o!aX#v!aX#w!aX#x!aX#y!aX#z!aX#{!aX$P!aX$X!aX$i!aX$T!aX~O}#hO~Of#jOg#kO$T#jOh!Sa!O!Sa!Q!Sa!W!Sa!X!Sa!]!Sa!j!Sa!l!Sa!m!Sa!n!Sa!o!Sa#v!Sa#w!Sa#x!Sa#y!Sa#z!Sa#{!Sa$P!Sa$X!Sa$i!Sa~O}#lO~O{#mO~O{#pO~O{#tO~O!OqO!QqO!WqO!XqO!]#xO$i#zO~O$X$PO~O$T$QO~O{$RO$X$TO~O$X$UO~P,tOf#|Xg#|Xh#|X!O#|X!j#|X!l#|X!m#|X!n#|X!o#|X#v#|X#w#|X#x#|X#y#|X#z#|X#{#|X$X#|X~O$T$VO~P<[O!s$XO~P.eO$W$YO~OX#pXY#pXi#pXj#pXk#pXl#pXm#pXn#pXo#pXp#pXq#pXr#pXs#pX!s#pX#v#pX#w#pX$S#pX$W#pX$Y#pX$Z#pX$[#pX$]#pX$^#pX$_#pX$`#pX$a#pX$b#pX$c#pX$d#pX$e#pX$f#pX$g#pX$h#pX~O_$[O`$[O~P=sO]!|O^!|O~P=sO$T$dO~P,tO$X$eO~O}$gO~Og$hOf![Xh![X!O![X!Q![X!W![X!X![X!]![X!j![X!l![X!m![X!n![X!o![X#v![X#w![X#x![X#y![X#z![X#{![X$P![X$X![X$i![X$T![X~O$W$iO~O}#XO!k$kO!q$lO!s$mO$V!_O~O!k$kO!q$lO!s$mO~O{#dO!`$nOf!^ag!^ah!^a!O!^a!Q!^a!W!^a!X!^a!]!^a!j!^a!l!^a!m!^a!n!^a!o!^a#v!^a#w!^a#x!^a#y!^a#z!^a#{!^a$P!^a$X!^a$i!^a$T!^a~O|$pOf!dXg!dXh!dX!O!dX!Q!dX!W!dX!X!dX!]!dX!j!dX!l!dX!m!dX!n!dX!o!dX#v!dX#w!dX#x!dX#y!dX#z!dX#{!dX$P!dX$T!dX$X!dX$i!dX~O$T$qOf!eag!eah!ea!O!ea!Q!ea!W!ea!X!ea!]!ea!j!ea!l!ea!m!ea!n!ea!o!ea#v!ea#w!ea#x!ea#y!ea#z!ea#{!ea$P!ea$X!ea$i!ea~O$T$qOf!bag!bah!ba!O!ba!Q!ba!W!ba!X!ba!]!ba!j!ba!l!ba!m!ba!n!ba!o!ba#v!ba#w!ba#x!ba#y!ba#z!ba#{!ba$P!ba$X!ba$i!ba~Of#jOg#kO$T#jO$X$rO~O|$tO~O$T$uOf!uag!uah!ua!O!ua!Q!ua!W!ua!X!ua!]!ua!j!ua!l!ua!m!ua!n!ua!o!ua#v!ua#w!ua#x!ua#y!ua#z!ua#{!ua$P!ua$X!ua$i!ua~O|!XO!O!XO!P!XO!Q!XOf!{Xg!{Xh!{X!W!{X!X!{X!]!{X!j!{X!l!{X!m!{X!n!{X!o!{X#v!{X#w!{X#x!{X#y!{X#z!{X#{!{X$P!{X$T!{X$X!{X$i!{X~O$T$vOf!yag!yah!ya!O!ya!Q!ya!W!ya!X!ya!]!ya!j!ya!l!ya!m!ya!n!ya!o!ya#v!ya#w!ya#x!ya#y!ya#z!ya#{!ya$P!ya$X!ya$i!ya~O|!XO!O!XO!P!XO!Q!XOf#OXg#OXh#OX!W#OX!X#OX!]#OX!j#OX!l#OX!m#OX!n#OX!o#OX#v#OX#w#OX#x#OX#y#OX#z#OX#{#OX$P#OX$T#OX$X#OX$i#OX~O$T$wOf!|ag!|ah!|a!O!|a!Q!|a!W!|a!X!|a!]!|a!j!|a!l!|a!m!|a!n!|a!o!|a#v!|a#w!|a#x!|a#y!|a#z!|a#{!|a$P!|a$X!|a$i!|a~OU$xO~P*eO!k${O~O!]$|O$i#zO~O!OqO!QqO!WqO!XqO!]#xO~OZ%OO$X#ca~P!$YO$X%TO~P;]O$X%UO~Od{Oe{Of#Qqg#Qqh#Qq!O#Qq!j#Qq!l#Qq!m#Qq!n#Qq!o#Qq#v#Qq#w#Qq#x#Qq#y#Qq#z#Qq#{#Qq$P#Qq$X#Qq$T#Qq~O$T%XO$X%YO~Od{Oe{Of#mqg#mqh#mq!O#mq!j#mq!l#mq!m#mq!n#mq!o#mq#v#mq#w#mq#x#mq#y#mq#z#mq#{#mq$P#mq$X#mq$T#mq~O$X%ZO~P,tO$T%]O~P<[O#u%^O$X%aO~OX#paY#pai#paj#pak#pal#pam#pan#pao#pap#paq#par#pas#pa!s#pa#v#pa#w#pa$S#pa$Y#pa$Z#pa$[#pa$]#pa$^#pa$_#pa$`#pa$a#pa$b#pa$c#pa$d#pa$e#pa$f#pa$g#pa$h#pa~O$W$YO~P!(cO_%cO`%cO$W#pa~P!(cOf!POh!PO!O!TO!j!TO!l!TO!m!TO!n!TO!o!TO#v!QO#w!QO#x#oq#y#oq#z#oq#{#oq$P#oq$X#oq~Og#oq~P!*}Of#oqg#oqh#oq~P!+TOg!OO~P!*}O$P#oq$X#oq~P%aOf#oqg#oqh#oq!O#oq!j#oq!l#oq!m#oq!n#oq!o#oq#x#oq#y#oq#z#oq#{#oq~O#v!QO#w!QO$P#oq$X#oq~P!,xO}%dO~O$X%eO~O}%gO~O$W%hO~O$T$qOf!eig!eih!ei!O!ei!Q!ei!W!ei!X!ei!]!ei!j!ei!l!ei!m!ei!n!ei!o!ei#v!ei#w!ei#x!ei#y!ei#z!ei#{!ei$P!ei$X!ei$i!ei~O}%iO~O{#dO~Of#jO$T#jOg!fih!fi!O!fi!Q!fi!W!fi!X!fi!]!fi!j!fi!l!fi!m!fi!n!fi!o!fi#v!fi#w!fi#x!fi#y!fi#z!fi#{!fi$P!fi$X!fi$i!fi~O{%kO}%kO~O{%pO$k%rO$l%sO$m%tO~OZ%OO$X#ci~O$j%vO~O$X#ci~P!$YO!k%yO~O!]$|O$X#ci~O$X%{O~P;]O!]$|O$X%{O$i#zO~O$X%}O~O{&OO~O$X&PO~P,tO$T&RO$X&SO~O$W$YOX#piY#pii#pij#pik#pil#pim#pin#pio#pip#piq#pir#pis#pi!s#pi#v#pi#w#pi$S#pi$Y#pi$Z#pi$[#pi$]#pi$^#pi$_#pi$`#pi$a#pi$b#pi$c#pi$d#pi$e#pi$f#pi$g#pi$h#pi~O$T&UO~O$X&VO~O}&WO~O$W&XO~Of#jOg#kO$T#jO!]#fi$i#fi$X#fi~O!]$|O$X#cq~O$X#cq~P!$YOZ%OO!]&[O$X#cq~Od{Oe{Of#Q!Rg#Q!Rh#Q!R!O#Q!R!j#Q!R!l#Q!R!m#Q!R!n#Q!R!o#Q!R#v#Q!R#w#Q!R#x#Q!R#y#Q!R#z#Q!R#{#Q!R$P#Q!R$X#Q!R$T#Q!R~Od{Oe{Of#m!Rg#m!Rh#m!R!O#m!R!j#m!R!l#m!R!m#m!R!n#m!R!o#m!R#v#m!R#w#m!R#x#m!R#y#m!R#z#m!R#{#m!R$P#m!R$X#m!R$T#m!R~O$X&_O~P,tO#u%^O$X&aO~O}&bO~O$X&cO~O{&dO~O!]$|O$X#cy~OZ%OO$X#cy~OU$xO~O!]&[O$X#cy~O$T&gO~O$X&hO~O!]$|O$X#c!R~O}&jO~O$T&kO~O}&lO~O$X&mO~OP!dOQ!cOR!fOS!eOT!eOV&nOW!kOa!mOb!nOc!oO{!bO$W!iO~O!]&oO$Twa~P+]O!]&oO$TwX~P#hOf&yOh&yO!O&}O!j&}O!l&}O!m&}O!n&}O!o&}O#v&zO#w&zO#x#oq#y#oq#z#oq#{#oq$T#oq~Og#oq~P!=oOf#oqg#oqh#oq~P!=uOg&xO~P!=oOf&yOg&xOh&yO!O&}O!j&}O!l&}O!m&}O!n&}O!o&}O#v&zO#w&zO#x&{O#y&{O#z&{O#{&|O~O$T#oq~P!?]O#v&zO#w&zO$T#oq~P!,xO",
  goto: "1P$PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$Q%P%h&W&ZPPPPPP&r'U'f't(VPP(f(n(wP)Q)VP)Q)Q)Y)c)Q)k)|)|*VPPPPPP*VP)|P)Q)Q*`*f)Q)Q*m*p)Q*v*y+P+r,X,n,n,n,n,n,n,n,n,n,n,n,n,n,n,n-T-^-q-}.g.j.j.j.m.|+r/P+r/f0[0m0v0yPPPPPPP+r+r+r[WOR|!{$V%]Q$^#PQ$_#QS$`#R&tQ$a#SQ$b#TQ$c#UQ'O&rQ'P&sQ'Q&uQ'R&vQ'S&wR'T!Vt^O|!V!{#P#Q#R#S#T#U$V%]&r&s&t&u&v&wRxRjQOR|!V!{#P#Q#R#S#T#U$V%]S!tz$QQ#}!u]&q&r&s&t&u&v&wRpPQoP^!hu!i#j#k#x$|&oQ#Y!YS#q!n$vT#u!o$wQwQQ#y!tQ$}#|Q%R#}Q%z%QR&p&q[vQ!t#|#}%Q&q]!qw#y$}%R%z&pitQw!t#y#|#}$}%Q%R%z&p&qhsQw!t#y#|#}$}%Q%R%z&p&qR!atkrQtw!t#y#|#}$}%Q%R%z&p&qQ!^rV#^!`#Z$hW![r!`#Z$hR$j#`Q#_!`Q$f#ZR%f$hV!pu#x&oR#c!cQ#f!cQ#g!dR$o#cU#e!c!d#cR%j$qU!ju#x&oQ#i!iQ$r#jQ$s#kR%w$|_!hu!i#j#k#x$|&o_!gu!i#j#k#x$|&oQ#o!lR&i&nS#n!l&nR%l$uR#s!nQ#r!nR%m$vR#w!oQ#v!oR%n$wj^O#P#Q#R#S#T#U&r&s&t&u&v&wQyRQ!y|Q#V!VQ$W!{Q%[$VR&Q%]w]OR|!V!{#P#Q#R#S#T#U$V%]&r&s&t&u&v&wwTOR|!V!{#P#Q#R#S#T#U$V%]&r&s&t&u&v&wwSOR|!V!{#P#Q#R#S#T#U$V%]&r&s&t&u&v&wQ!vzQ$O!uR%W$QS#|!t#}W$z#y#{%R%SQ%u$yQ%|%TR&Z%{Q%Q#|Q%u$zQ&]%|R&e&ZQ#{!tS$y#y%RQ%P#|Q%S#}S%x$}%QS&Y%z%|R&f&]R%q$xR%o$xQ}VQ%V$PQ%Z$UQ&^%}R&_&PR$S!xwVOR|!V!{#P#Q#R#S#T#U$V%]&r&s&t&u&v&wQ#P!OQ#Q!PQ#R!QQ#S!RQ#T!SQ#U!TQ&r&xQ&s&yQ&t&zQ&u&{Q&v&|R&w&}h!}!O!P!Q!R!S!T&x&y&z&{&|&}R$]#OQ$Z!|Q%b$[R&T%cR%_$YQ%`$YR&`&R",
  nodeNames: "⚠ Json Logfmt Unpack Pattern Regexp Unwrap LabelFormat LineFormat LabelReplace Vector Offset Bool On Ignoring GroupLeft GroupRight Decolorize Drop Keep By Without And Or Unless Sum Avg Count Max Min Stddev Stdvar Bottomk Topk Sort Sort_Desc LineComment LogQL Expr LogExpr Selector Matchers Matcher Identifier Eq String Neq Re Nre PipelineExpr PipelineStage LineFilters LineFilter Filter PipeExact PipeMatch FilterOp Ip OrFilter Pipe LogfmtParser LogfmtParserFlags ParserFlag LabelParser JsonExpressionParser LabelExtractionExpressionList LabelExtractionExpression LogfmtExpressionParser LabelFilter IpLabelFilter UnitFilter DurationFilter Gtr Duration Gte Lss Lte Eql BytesFilter Bytes NumberFilter Number LineFormatExpr LabelFormatExpr LabelsFormat LabelFormatMatcher DecolorizeExpr DropLabelsExpr DropLabels DropLabel KeepLabelsExpr KeepLabels KeepLabel MetricExpr RangeAggregationExpr RangeOp CountOverTime Rate RateCounter BytesOverTime BytesRate AvgOverTime SumOverTime MinOverTime MaxOverTime StddevOverTime StdvarOverTime QuantileOverTime FirstOverTime LastOverTime AbsentOverTime LogRangeExpr Range OffsetExpr UnwrapExpr ConvOp BytesConv DurationConv DurationSecondsConv Grouping Labels VectorAggregationExpr VectorOp BinOpExpr BinOpModifier OnOrIgnoringModifier GroupingLabels GroupingLabelList GroupingLabel LabelName Add Sub Mul Div Mod Pow LiteralExpr LabelReplaceExpr VectorExpr",
  maxTerm: 167,
  skippedNodes: [0,36],
  repeatNodeCount: 0,
  tokenData: "5b~RvX^#ipq#iqr$^rs$qst%cuv%nxy%syz%xz{%}{|&S|}&X}!O&^!O!P(l!P!Q)l!Q!R)q!R![+X![!]2X!^!_2m!_!`2z!`!a3a!c!}3n!}#O4U#P#Q4Z#Q#R4`#R#S3n#S#T4e#T#o3n#o#p4q#p#q4v#q#r5]#y#z#i$f$g#i#BY#BZ#i$IS$I_#i$I|$JO#i$JT$JU#i$KV$KW#i&FU&FV#i~#nY$R~X^#ipq#i#y#z#i$f$g#i#BY#BZ#i$IS$I_#i$I|$JO#i$JT$JU#i$KV$KW#i&FU&FV#i~$aQ!_!`$g#r#s$l~$lO!O~~$qO!Q~~$tUOY$qZr$qrs%Ws#O$q#O#P%]#P~$q~%]O}~~%`PO~$q~%hQt~OY%cZ~%c~%sO#z~~%xO$W~~%}O$X~~&SO#x~~&XO#v~~&^O$T~~&cP#w~}!O&f~&iQ#_#`&o#g#h'|~&rP#X#Y&u~&xP#X#Y&{~'OP#d#e'R~'UP}!O'X~'[P#X#Y'_~'bP#a#b'e~'hP#d#e'k~'nP#h#i'q~'tP#m#n'w~'|O!`~~(PP#h#i(S~(VP#f#g(Y~(]P#]#^(`~(cP#V#W(f~(iP#h#i'w~(oP!Q![(r~(wR!s~!Q![(r!g!h)Q#X#Y)Q~)TR{|)^}!O)^!Q![)d~)aP!Q![)d~)iP!s~!Q![)d~)qO#y~~)ve!s~!O!P(r!Q![+X!g!h,l!i!j-Z!m!n-Z!o!p-Z!r!s-Z!v!w-Z#U#V-O#W#X-d#X#Y/f#Z#[/x#[#]-{#_#`/x#a#b0R#d#e/x#g#h/T#h#i/x#k#l0d#l#m1m#m#n1O~+^d!s~!O!P(r!Q![+X!g!h,l!i!j-Z!m!n-Z!o!p-Z!r!s-Z!v!w-Z#U#V-O#W#X-d#X#Y/f#Z#[/x#[#]-{#_#`/x#a#b0R#d#e/x#g#h/T#h#i/x#k#l0d#m#n1O~,oT{|)^}!O)^!Q![)d!d!e-O#]#^-T~-TO!q~~-WP#U#V-O~-^Q!d!e-O#]#^-T~-iP!k~!Q![-l~-oS!Q![-l#[#]-{#a#b.a#g#h/T~.QP!k~!Q![.T~.WR!Q![.T#a#b.a#g#h/T~.fQ!k~!Q![.l#g#h/O~.oR!Q![.l#a#b.x#g#h/T~.{P#g#h/O~/TO!k~~/YP!k~!Q![/]~/`Q!Q![/]#a#b.x~/iT{|)^}!O)^!Q![)d#U#V-O#]#^-T~/{Q#U#V-O#]#^-T~0WS!k~!Q![.l#U#V-O#]#^-T#g#h/O~0iP!k~!Q![0l~0oT!Q![0l#W#X-d#[#]-{#a#b.a#g#h/T~1TP!k~!Q![1W~1ZU!Q![1W#W#X-d#[#]-{#a#b.a#g#h/T#k#l0d~1pR!Q![1y!c!i1y#T#Z1y~2OR!s~!Q![1y!c!i1y#T#Z1yP2^T{P!Q![2X![!]2X!c!}2X#R#S2X#T#o2X~2rP!m~!_!`2u~2zO!n~~3PQ|~!_!`3V#r#s3[~3[O!o~~3aO!P~~3fP!j~!_!`3i~3nO!l~R3uT{P#uQ!Q![3n![!]2X!c!}3n#R#S3n#T#o3n~4ZO$i~~4`O$j~~4eO#{~~4hRO#S4e#S#T%W#T~4e~4vO$S~~4{Q!]~!_!`5R#r#s5W~5WO!W~~5]O!X~~5bO$U~",
  tokenizers: [0, 1],
  topRules: {"LogQL":[0,37]},
  specialized: [{term: 43, get: (value, stack) => (specializeIdentifier(value) << 1)},{term: 43, get: (value, stack) => (extendIdentifier(value) << 1) | 1},{term: 43, get: value => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const Json = 1,
  Logfmt = 2,
  Unpack = 3,
  Pattern = 4,
  Regexp = 5,
  Unwrap = 6,
  LabelFormat = 7,
  LineFormat = 8,
  LabelReplace = 9,
  Vector = 10,
  Offset = 11,
  Bool = 12,
  On = 13,
  Ignoring = 14,
  GroupLeft = 15,
  GroupRight = 16,
  Decolorize = 17,
  Drop = 18,
  Keep = 19,
  By = 20,
  Without = 21,
  And = 22,
  Or = 23,
  Unless = 24,
  Sum = 25,
  Avg = 26,
  Count = 27,
  Max = 28,
  Min = 29,
  Stddev = 30,
  Stdvar = 31,
  Bottomk = 32,
  Topk = 33,
  Sort = 34,
  Sort_Desc = 35,
  LineComment = 36,
  LogQL = 37,
  Expr = 38,
  LogExpr = 39,
  Selector = 40,
  Matchers = 41,
  Matcher = 42,
  Identifier = 43,
  Eq = 44,
  String = 45,
  Neq = 46,
  Re = 47,
  Nre = 48,
  PipelineExpr = 49,
  PipelineStage = 50,
  LineFilters = 51,
  LineFilter = 52,
  Filter = 53,
  PipeExact = 54,
  PipeMatch = 55,
  FilterOp = 56,
  Ip = 57,
  OrFilter = 58,
  Pipe = 59,
  LogfmtParser = 60,
  LogfmtParserFlags = 61,
  ParserFlag = 62,
  LabelParser = 63,
  JsonExpressionParser = 64,
  LabelExtractionExpressionList = 65,
  LabelExtractionExpression = 66,
  LogfmtExpressionParser = 67,
  LabelFilter = 68,
  IpLabelFilter = 69,
  UnitFilter = 70,
  DurationFilter = 71,
  Gtr = 72,
  Duration = 73,
  Gte = 74,
  Lss = 75,
  Lte = 76,
  Eql = 77,
  BytesFilter = 78,
  Bytes = 79,
  NumberFilter = 80,
  Number = 81,
  LineFormatExpr = 82,
  LabelFormatExpr = 83,
  LabelsFormat = 84,
  LabelFormatMatcher = 85,
  DecolorizeExpr = 86,
  DropLabelsExpr = 87,
  DropLabels = 88,
  DropLabel = 89,
  KeepLabelsExpr = 90,
  KeepLabels = 91,
  KeepLabel = 92,
  MetricExpr = 93,
  RangeAggregationExpr = 94,
  RangeOp = 95,
  CountOverTime = 96,
  Rate = 97,
  RateCounter = 98,
  BytesOverTime = 99,
  BytesRate = 100,
  AvgOverTime = 101,
  SumOverTime = 102,
  MinOverTime = 103,
  MaxOverTime = 104,
  StddevOverTime = 105,
  StdvarOverTime = 106,
  QuantileOverTime = 107,
  FirstOverTime = 108,
  LastOverTime = 109,
  AbsentOverTime = 110,
  LogRangeExpr = 111,
  Range = 112,
  OffsetExpr = 113,
  UnwrapExpr = 114,
  ConvOp = 115,
  BytesConv = 116,
  DurationConv = 117,
  DurationSecondsConv = 118,
  Grouping = 119,
  Labels = 120,
  VectorAggregationExpr = 121,
  VectorOp = 122,
  BinOpExpr = 123,
  BinOpModifier = 124,
  OnOrIgnoringModifier = 125,
  GroupingLabels = 126,
  GroupingLabelList = 127,
  GroupingLabel = 128,
  LabelName = 129,
  Add = 130,
  Sub = 131,
  Mul = 132,
  Div = 133,
  Mod = 134,
  Pow = 135,
  LiteralExpr = 136,
  LabelReplaceExpr = 137,
  VectorExpr = 138;

function getNodeFromQuery(query, nodeType) {
  const nodes = [];
  const tree = parser.parse(query);
  tree.iterate({
    enter: (node) => {
      if (nodeType === undefined || nodeType === node.type.id) {
        nodes.push(node.node);
      }
    },
  });
  return nodes[0];
}

function isLogsQuery(query) {
  if (getNodeFromQuery(query, MetricExpr$1)) {
    return false;
  }
  return true;
}

function indent(level) {
  return '  '.repeat(level);
}

function indentMultiline(block, level) {
  const lines = block.split('\n');
  return lines.map((line) => indent(level) + line).join('\n');
}

function trimMultiline(block) {
  const lines = block.split('\n');
  return lines.map((line) => line.trimEnd()).join('\n');
}

function needsBrackets(node, queryType) {
  const childNodeIsSame = node.firstChild?.type.id === queryType;
  let addBrackets = false;

  if (node.firstChild && childNodeIsSame) {
    addBrackets = true;
    node = node.firstChild;
  }

  return { addBrackets, newNode: node };
}

function iterateNode(node, lookingFor) {
  const nodes = [];
  let child = node.firstChild;

  while (child) {
    if (lookingFor.includes(child.type.id)) {
      nodes.push(child);
    }

    nodes.push(...iterateNode(child, lookingFor));
    child = child.nextSibling;
  }

  return nodes;
}

function buildResponse(pipelineType, lastPipelineType, formattedNode) {
  if (lastPipelineType === pipelineType) {
    return ` ${formattedNode}`;
  }

  return `\n${indent(1)}${formattedNode}`;
}

function trimEnd(input, charactersToTrim) {
  let endIndex = input.length - 1;
  while (endIndex >= 0 && charactersToTrim.includes(input[endIndex])) {
    endIndex--;
  }
  return input.substring(0, endIndex + 1);
}

const formatLogExpr = (node, query) => {
  const { addBrackets, newNode } = needsBrackets(node, LogExpr);
  node = newNode;

  const tree = parser.parse(query.substring(node.from, node.to));
  let formatted = '';

  tree.iterate({
    enter: (ref) => {
      const node = ref.node;

      switch (node.type.id) {
        case Selector:
          formatted += formatSelector(node, query);
          break;

        case PipelineExpr:
          node.parent?.type.id !== PipelineExpr && (formatted += formatPipelineExpr(node, query));
          break;
      }
    },
  });

  return addBrackets ? '(' + formatted + ')' : formatted;
};

function formatSelector(node, query) {
  const selector = query.substring(node.from, node.to);
  const subtree = parser.parse(selector);
  const labelNodes = [];
  let response = '';

  subtree.iterate({
    enter: (ref) => {
      const node = ref.node;
      if (node.type.id === Matcher) {
        labelNodes.push(node);
      }
    },
  });

  labelNodes.sort((a, b) => {
    const labelNodeA = a.getChild(Identifier);
    const labelNodeB = b.getChild(Identifier);

    const labelValueA = labelNodeA && query.substring(labelNodeA.from, labelNodeA.to);
    const labelValueB = labelNodeB && query.substring(labelNodeB.from, labelNodeB.to);

    if (!labelValueA || !labelValueB) {
      return 0;
    }

    if (labelValueA < labelValueB) {
      return -1;
    }

    if (labelValueA > labelValueB) {
      return 1;
    }

    return 0;
  });

  labelNodes.forEach((node) => {
    const labelNode = node.getChild(Identifier);
    const operatorNode = labelNode ? labelNode.nextSibling : null;
    const valueNode = node.getChild(String);

    const label = labelNode ? query.substring(labelNode.from, labelNode.to) : null;
    const operator = operatorNode ? query.substring(operatorNode.from, operatorNode.to) : null;
    const value = valueNode ? query.substring(valueNode.from, valueNode.to) : null;

    response += `${label}${operator}${value}, `;
  });

  return '{' + trimEnd(response, ', ') + '}';
}

function formatPipelineExpr(node, query) {
  const pipelineExprNodes = [
    LineFilter,
    LabelParser,
    LogfmtParser,
    LabelFilter,
    JsonExpressionParser,
    LineFormatExpr,
    LabelFormatExpr,
    DecolorizeExpr,
  ];
  let lastPipelineType;
  let response = '';

  iterateNode(node, pipelineExprNodes).forEach((node) => {
    switch (node.type.id) {
      case LineFilter:
        response += buildResponse(LineFilter, lastPipelineType, formatLineFilter(node, query));
        lastPipelineType = LineFilter;
        break;

      case LabelParser:
        response += buildResponse(LabelParser, lastPipelineType, formatLabelParser(node, query));
        lastPipelineType = LabelParser;
        break;

      case LogfmtParser:
        response += buildResponse(LogfmtParser, lastPipelineType, formatLabelParser(node, query));
        lastPipelineType = LogfmtParser;
        break;

      case JsonExpressionParser:
        response += buildResponse(JsonExpressionParser, lastPipelineType, formatJsonExpressionParser(node, query));
        lastPipelineType = JsonExpressionParser;
        break;

      case LabelFilter:
        response += buildResponse(LabelFilter, lastPipelineType, formatLabelFilter(node, query));
        lastPipelineType = LabelFilter;
        break;

      case LineFormatExpr:
        response += buildResponse(LineFormatExpr, lastPipelineType, formatLineFormatExpr(node, query));
        lastPipelineType = LineFormatExpr;
        break;

      case LabelFormatExpr:
        response += buildResponse(LabelFormatExpr, lastPipelineType, formatLabelFormatExpr(node, query));
        lastPipelineType = LabelFormatExpr;
        break;

      case DecolorizeExpr:
        response += buildResponse(DecolorizeExpr, lastPipelineType, formatDecolorizeExpr());
        lastPipelineType = DecolorizeExpr;
        break;
    }
  });

  return response;
}

function formatLineFilter(node, query) {
  const filterNode = node.getChild(Filter);
  const filterOperationNode = node.getChild(FilterOp);
  const stringNode = node.getChild(String);

  const filter = filterNode && query.substring(filterNode.from, filterNode.to);
  const string = stringNode && query.substring(stringNode.from, stringNode.to);

  if (filterOperationNode) {
    return `${filter} ip(${string})`;
  }
  return `${filter} ${string}`;
}

function formatLabelParser(node, query) {
  const hasString = node.getChild(String);

  if (hasString) {
    const parserNode = node.getChild(Regexp) || node.getChild(Pattern);
    const stringNode = node.getChild(String);

    const parser = parserNode && query.substring(parserNode.from, parserNode.to);
    const string = stringNode && query.substring(stringNode.from, stringNode.to);

    return `| ${parser}${string}`;
  }

  const labelParser = query.substring(node.from, node.to);
  return `| ${labelParser}`;
}

function formatJsonExpressionParser(node, query) {
  const jsonExpressionNodes = iterateNode(node, [LabelExtractionExpression]);
  let response = '';

  jsonExpressionNodes.forEach((node) => {
    const identifierNode = node.getChild(Identifier);
    const valueNode = node.getChild(String);

    const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
    const value = valueNode && query.substring(valueNode.from, valueNode.to);

    response += `${identifier}=${value}, `;
  });

  return `| json ${trimEnd(response, ', ')}`;
}

function formatLabelFilter(node, query) {
  const selectedFilter =
    node.getChild(Matcher) ||
    node.getChild(IpLabelFilter) ||
    node.getChild(NumberFilter) ||
    node.getChild(UnitFilter)?.getChild(DurationFilter) ||
    node.getChild(UnitFilter)?.getChild(BytesFilter);

  if (!selectedFilter) {
    return '';
  }

  const selectedFilterType = selectedFilter.type.id;

  const identifierNode = selectedFilter.getChild(Identifier);
  const operatorNode = identifierNode && identifierNode.nextSibling;
  let valueNode;

  if (selectedFilterType === DurationFilter) {
    valueNode = selectedFilter.getChild(Duration);
  } else if (selectedFilterType === BytesFilter) {
    valueNode = selectedFilter.getChild(Bytes);
  } else if (selectedFilterType === NumberFilter) {
    valueNode = selectedFilter.getChild(Number);
  } else {
    valueNode = selectedFilter.getChild(String);
  }

  const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
  const operator = operatorNode && query.substring(operatorNode.from, operatorNode.to);
  const value = valueNode && query.substring(valueNode.from, valueNode.to);

  if (selectedFilterType === IpLabelFilter) {
    return `| ${identifier}${operator}ip(${value})`;
  }

  return `| ${identifier}${operator}${value}`;
}

function formatLineFormatExpr(node, query) {
  const stringNode = node.getChild(String);
  const string = stringNode && query.substring(stringNode.from, stringNode.to);
  return `| line_format ${string}`;
}

function formatLabelFormatExpr(node, query) {
  const labelFormatMatcherNodes = iterateNode(node, [LabelFormatMatcher]);
  let response = '| label_format ';

  labelFormatMatcherNodes.forEach((labelFormatMatcherNode) => {
    let identifierNode;
    let valueNode;

    if (labelFormatMatcherNode.getChildren(Identifier).length === 2) {
      [identifierNode, valueNode] = labelFormatMatcherNode.getChildren(Identifier);
    } else {
      identifierNode = labelFormatMatcherNode.getChild(Identifier);
      valueNode = labelFormatMatcherNode.getChild(String);
    }

    const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
    const value = valueNode && query.substring(valueNode.from, valueNode.to);

    response += `${identifier}=${value}, `;
  });

  return trimEnd(response, ', ');
}

function formatDecolorizeExpr() {
  return `| decolorize`;
}

const formatMetricExpr = (node, query) => {
  const { addBrackets, newNode } = needsBrackets(node, MetricExpr);
  node = newNode;
  let formatted = '';

  const childNode = node.firstChild;
  switch (childNode && childNode.type.id) {
    case RangeAggregationExpr:
      formatted = formatRangeAggregationExpr(node, query);
      break;

    case VectorAggregationExpr:
      formatted = formatVectorAggregationExpr(node, query);
      break;

    case BinOpExpr:
      formatted = formatBinOpExpr(node, query);
      break;

    case LiteralExpr:
      formatted = formatLiteralExpr(node, query);
      break;

    case LabelReplaceExpr:
      formatted = formatLabelReplaceExpr(node, query);
      break;

    case VectorExpr:
      formatted = formatVectorExpr(node, query);
      break;
  }

  return addBrackets ? '(' + formatted + ')' : formatted;
};

function formatRangeAggregationExpr(node, query) {
  let response = '';

  iterateNode(node, [RangeOp, Number, LogRangeExpr, Grouping]).forEach((node) => {
    if (node.parent?.type.id !== RangeAggregationExpr) {
      return;
    }

    switch (node.type.id) {
      case RangeOp:
        response += `${query.substring(node.from, node.to)}(\n`;
        break;

      case Number:
        response += `${indent(1) + query.substring(node.from, node.to)},\n`;
        break;

      case LogRangeExpr:
        response += formatLogRangeExpr(node, query);
        break;

      case Grouping:
        response += formatGrouping(node, query);
        break;
    }
  });

  return response;
}

function formatLogRangeExpr(node, query) {
  const nodes = [];
  let selector = '';
  let pipeline = '';
  let range = '';
  let offset = '';
  let unwrap = '';

  iterateNode(node, [Selector, Range, OffsetExpr, UnwrapExpr, PipelineExpr]).forEach((node) => {
    if (node.parent?.type.id !== LogRangeExpr) {
      return;
    }

    nodes.push(node);

    switch (node.type.id) {
      case Selector: {
        let logExpr = query.substring(node.from, node.to);
        selector += formatSelector({ ...node, from: 0, to: logExpr.length }, logExpr);
        break;
      }

      case PipelineExpr:
        pipeline += formatPipelineExpr(node, query);
        break;

      case Range:
        range += query.substring(node.from, node.to);
        break;

      case OffsetExpr: {
        const durationNode = node.getChild(Duration);
        offset += ` offset ${durationNode ? query.substring(durationNode.from, durationNode.to) : ''}`;
        break;
      }

      case UnwrapExpr:
        iterateNode(node, [Identifier, ConvOp, LabelFilter]).forEach((node, _, arr) => {
          switch (node.type.id) {
            case Identifier: {
              if (node.parent?.type.id !== UnwrapExpr) {
                return;
              }

              const hasConvOp = arr.find((node) => node.type.id === ConvOp);

              if (hasConvOp) {
                return;
              }

              unwrap += `| unwrap ${query.substring(node.from, node.to)} `;
              return;
            }

            case ConvOp: {
              const identifierNode = arr.find((node) => node.type.id === Identifier);
              const identifier = identifierNode ? query.substring(identifierNode.from, identifierNode.to) : '';
              unwrap += `| unwrap ${query.substring(node.from, node.to)}(${identifier}) `;
              return;
            }

            case LabelFilter:
              unwrap += formatLabelFilter(node, query);
              return;
          }
        });
        break;
    }
  });

  let response = '';
  nodes.forEach((node, index, array) => {
    const previousNode = array[index - 1];

    if (node.type.id === Selector) {
      response += indent(1) + selector;
    }

    if (node.type.id === PipelineExpr) {
      response += indentMultiline(pipeline, 1);
    }

    if (node.type.id === Range) {
      response += '\n' + indent(1) + range;
    }

    if (node.type.id === OffsetExpr) {
      response += offset;
    }

    if (node.type.id === UnwrapExpr) {
      if (previousNode?.type.id !== OffsetExpr && previousNode?.type.id !== Range) {
        response += '\n' + indent(1) + unwrap;
      } else {
        response += ' ' + unwrap;
      }
    }
  });

  return (response += '\n)');
}

function formatGrouping(node, query) {
  let response = '';

  const labels = iterateNode(node, [Identifier]).map((node) => {
    return query.substring(node.from, node.to);
  });

  iterateNode(node, [By, Without]).forEach((node) => {
    if (node.parent?.type.id !== Grouping) {
      return;
    }

    switch (node.type.id) {
      case By:
        response = ` by (${labels.join(', ')}) `;
        break;

      case Without:
        response = ` without (${labels.join(', ')}) `;
        break;
    }
  });

  return response;
}

function formatVectorAggregationExpr(node, query) {
  let response = '';

  iterateNode(node, [VectorOp, Number, MetricExpr, Grouping]).forEach((node, _, arr) => {
    if (node.parent?.type.id !== VectorAggregationExpr) {
      return;
    }

    switch (node.type.id) {
      case VectorOp:
        response += `${query.substring(node.from, node.to)}`;
        break;

      case Number:
        response += `(\n`;
        response += `${indent(1) + query.substring(node.from, node.to)},\n`;
        break;

      case MetricExpr: {
        const hasNumber = arr.find((node) => node.type.id === Number && node.parent?.type.id === VectorAggregationExpr);
        response += hasNumber ? '' : '(\n';

        const metricExpr = query.substring(node.from, node.to);
        const metricNode = getNodeFromQuery(metricExpr, MetricExpr);
        response += indentMultiline(formatMetricExpr(metricNode, metricExpr), 1);
        response += '\n)';
        break;
      }

      case Grouping:
        response += formatGrouping(node, query);
        break;
    }
  });

  return response;
}

function formatBinOpExpr(node, query) {
  let operator;

  const [leftExpr, rightExpr] = iterateNode(node, [Expr]).map((node, idx) => {
    if (idx === 0) {
      operator = query.substring(node.nextSibling?.from ?? 0, node.nextSibling?.to);
    }

    const expr = query.substring(node.from, node.to);
    let expressionNode;

    if (isLogsQuery(expr)) {
      expressionNode = getNodeFromQuery(expr, LogExpr);
      return formatLogExpr(expressionNode, expr);
    } else {
      expressionNode = getNodeFromQuery(expr, MetricExpr);
      return formatMetricExpr(expressionNode, expr);
    }
  });

  return leftExpr + '\n' + operator + '\n' + rightExpr;
}

function formatLiteralExpr(node, query) {
  node = node.getChild(LiteralExpr) ?? node;
  const addNode = node.getChild(Add);
  const subNode = node.getChild(Sub);
  const numberNode = node.getChild(Number);

  if (!numberNode) {
    return '';
  }

  if (addNode) {
    return `+${query.substring(numberNode.from, numberNode.to)}`;
  }

  if (subNode) {
    return `-${query.substring(numberNode.from, numberNode.to)}`;
  }

  return query.substring(numberNode.from, numberNode.to);
}

function formatLabelReplaceExpr(node, query) {
  let response = 'label_replace(\n';

  iterateNode(node, [MetricExpr, String]).forEach((node) => {
    if (node.parent?.type.id !== LabelReplaceExpr) {
      return;
    }

    if (node.type.id === MetricExpr) {
      const metricExpr = query.substring(node.from, node.to);
      const metricNode = getNodeFromQuery(metricExpr, MetricExpr);
      response += indentMultiline(formatMetricExpr(metricNode, metricExpr), 1) + ',\n';
    } else {
      response += indent(1) + query.substring(node.from, node.to) + ',\n';
    }
  });

  return trimEnd(response, ',\n') + '\n)';
}

function formatVectorExpr(node, query) {
  node = node.getChild(VectorExpr) ?? node;
  const numberNode = node.getChild(Number);

  if (!numberNode) {
    return '';
  }

  return `vector(${query.substring(numberNode.from, numberNode.to)})`;
}

/**
 * @experimental This feature is subject to change or removal in future versions.
 */
const formatLokiQuery = (query) => {
  const tree = parser.parse(query);
  let formatted = '';

  tree.iterate({
    enter: (ref) => {
      const node = ref.node;

      if (node.parent?.type.id !== Expr || node.parent?.parent?.type.id === BinOpExpr) {
        return;
      }

      switch (node.type.id) {
        case MetricExpr:
          formatted = formatMetricExpr(node, query);
          return false;

        case LogExpr:
          formatted = formatLogExpr(node, query);
          return false;
      }
    },
  });

  return trimMultiline(formatted);
};

export { AbsentOverTime, Add, And, Avg, AvgOverTime, BinOpExpr, BinOpModifier, Bool, Bottomk, By, Bytes, BytesConv, BytesFilter, BytesOverTime, BytesRate, ConvOp, Count, CountOverTime, Decolorize, DecolorizeExpr, Div, Drop, DropLabel, DropLabels, DropLabelsExpr, Duration, DurationConv, DurationFilter, DurationSecondsConv, Eq, Eql, Expr, Filter, FilterOp, FirstOverTime, GroupLeft, GroupRight, Grouping, GroupingLabel, GroupingLabelList, GroupingLabels, Gte, Gtr, Identifier, Ignoring, Ip, IpLabelFilter, Json, JsonExpressionParser, Keep, KeepLabel, KeepLabels, KeepLabelsExpr, LabelExtractionExpression, LabelExtractionExpressionList, LabelFilter, LabelFormat, LabelFormatExpr, LabelFormatMatcher, LabelName, LabelParser, LabelReplace, LabelReplaceExpr, Labels, LabelsFormat, LastOverTime, LineComment, LineFilter, LineFilters, LineFormat, LineFormatExpr, LiteralExpr, LogExpr, LogQL, LogRangeExpr, Logfmt, LogfmtExpressionParser, LogfmtParser, LogfmtParserFlags, Lss, Lte, Matcher, Matchers, Max, MaxOverTime, MetricExpr, Min, MinOverTime, Mod, Mul, Neq, Nre, Number, NumberFilter, Offset, OffsetExpr, On, OnOrIgnoringModifier, Or, OrFilter, ParserFlag, Pattern, Pipe, PipeExact, PipeMatch, PipelineExpr, PipelineStage, Pow, QuantileOverTime, Range, RangeAggregationExpr, RangeOp, Rate, RateCounter, Re, Regexp, Selector, Sort, Sort_Desc, Stddev, StddevOverTime, Stdvar, StdvarOverTime, String, Sub, Sum, SumOverTime, Topk, UnitFilter, Unless, Unpack, Unwrap, UnwrapExpr, Vector, VectorAggregationExpr, VectorExpr, VectorOp, Without, formatLokiQuery, parser };
